import { ISymbolListResponseCounters } from '@cbridge-utils/datagrid';
import { makeCompositeId } from '@cbridge-utils/formatters';
import { INode } from '@cbridge-packages/node';
import { IServer } from '@cbridge-packages/server';
import { IStream } from '@cbridge-packages/stream';
import { ISymbolClientNodeKey, ISymbolClientServerKey, ClientSymbolFilter } from '../symbolClient.interface';

interface ICounterCacheParams {
  nodeId?: INode['nodeId'];
  serverId?: IServer['serverId'];
  streamId?: IStream['streamId'];
  symbolGroup?: string;
  filter?: ClientSymbolFilter;
  search?: string;
}

export const makeClientSymbolCountersCacheId = (params: ICounterCacheParams) => {
  const {
    nodeId,
    serverId,
    streamId = '-',
    symbolGroup = '-',
    filter = '-',
    search = '-',
  } = params;

  return makeCompositeId([serverId ?? nodeId, streamId, symbolGroup, filter, search]);
};

type ICountersData = [string, ISymbolListResponseCounters];

export const makeClientSymbolCountersCache =
  <R extends ISymbolListResponseCounters>(request: ISymbolClientNodeKey | ISymbolClientServerKey, response: R): ICountersData => {
    const { filteredCount, totalCount, unmappedCount } = response;

    return [
      makeClientSymbolCountersCacheId(request),
      { filteredCount, totalCount, unmappedCount },
    ];
  };
